import React from 'react';
import { connect } from 'react-redux';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';

function SystemManagementContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/system/dispensers"
        pathPermissionId={UserPermissionsIds.ReadMMTCs}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/mmtc/mmtcs',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/dispenser/:id"
        pathPermissionId={UserPermissionsIds.ReadMMTCs}
        render={(props) => {
          return (
            ViewMounter(props, {
              viewPath: 'system/mmtc/mmtc_profile',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              focusView: true,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              params: undefined
            })
          );
        }}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/dispenser/add"
        pathPermissionId={UserPermissionsIds.CreateMMTCs}
        render={(props) => {
          return (
            ViewMounter(props, {
              viewPath: 'system/mmtc/mmtc_profile',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              focusView: true,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              params: { isNew: true }
            })
          );
        }}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/organizations"
        pathPermissionId={UserPermissionsIds.ReadLEOs}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/leo/leos',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/restricted-physicians"
        pathPermissionId={UserPermissionsIds.AccessRestrictedPhysicians}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/restricted_physicians/restricted_physician_list',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/:id/restricted"
        pathPermissionId={UserPermissionsIds.AccessRestrictedPhysician}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/restricted_physicians/form/override_physician_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/user-roles"
        pathPermissionId={UserPermissionsIds.AccessUserRoles}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/user_roles/user_roles_screen',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/mqa-toggles"
        pathPermissionId={UserPermissionsIds.AccessMQAToggle}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/mqa_toggle/mqa_toggles',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/content-management/dashboard"
        pathPermissionId={UserPermissionsIds.AccessContentManagement}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/content_management/content_management_dashboard',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/content-management/add"
        pathPermissionId={UserPermissionsIds.CreateContentManagement}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/content_management/content_management_add',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/content-management/edit/:id"
        pathPermissionId={UserPermissionsIds.AccessContentManagement}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/content_management/content_management_edit.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/content-management/preview"
        pathPermissionId={UserPermissionsIds.ReadContentManagement}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/content_management/content_management_preview.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/system-action-history"
        pathPermissionId={UserPermissionsIds.AccessAdminSystemHistory}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/history/system_action_history',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/system/system-action-history/:historyOption/:orderId"
        pathPermissionId={UserPermissionsIds.AccessAdminSystemHistory}
        render={(props) => ViewMounter(props, {
          viewPath: 'system/history/system_action_history',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    empty: state.empty,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemManagementContainerScreen);
